import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query ServiceCostsGridQuery(
    $startRow: Int
    $endRow: Int
    $sortModel: [Sort]
    $filters: [Filter]
    $companyId: ID!
    $usageUnitId: ID!
  ) {
    Me {
      Company(id: $companyId) {
        UsageUnit(id: $usageUnitId) {
          data: serviceCosts(
            options: {
              startRow: $startRow
              endRow: $endRow
              sorting: $sortModel
              filters: $filters
            }
          ) {
            id
            status
            tenant {
              id
              firstname
              lastname
            }
            proofOfPerformance
            yearOfService
            netValue
          }
        }
      }
    }
  }
`
